



























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

// Interface
import { IDropdownList, IPageFilterModel } from '@/_interfaces'

// Components
import FilterDropdown from '@/components/shared/FilterDropdown.vue'

@Component({
  components: { FilterDropdown },
})
export default class DropdownSearch<T> extends Vue {
  @Prop()
  label!: string

  @Prop()
  selectedFilter!: string

  @Prop()
  searchQuery!: string

  @Prop()
  dropdownList!: IDropdownList[]

  @Prop()
  filteredData!: T[]

  @Prop()
  placeHolder?: string

  dropdownQuery: string = ''

  @Watch('dropdownQuery')
  queryChange() {
    this.$emit('update:searchQuery', this.dropdownQuery)
  }

  handleChange(val) {
    this.$emit('update:selectedFilter', val)
  }

  created() {
    this.dropdownQuery = this.searchQuery
  }
}
